import {
  defCreateWithQuery,
  defFetchList,
  defFetchFields,
  defFetchOne
} from '@/api/default'

const BASE_PATH = '/statement_orders_set'

export function fetchList (query) {
  return defFetchList(BASE_PATH, query)
}

export function fetchFields () {
  return defFetchFields(BASE_PATH)
}

export function fetchOne (id) {
  return defFetchOne(BASE_PATH, id)
}

export function exportData (q, fields) {
  return defCreateWithQuery(BASE_PATH + '/export', q, fields)
}
